import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ADD_RESPONSE = gql`
  mutation respondUserInstruction(
    $instructionId: ID!
    $token: String
    $data: RespondInstructionInput!
  ) {
    respondUserInstruction(
      instructionId: $instructionId
      token: $token
      data: $data
    ) {
      status
      message
    }
  }
`;
